// Explicitly expose the function to the global scope
window.toggleDropdown = function(toggleElement) {
    const dropdown = toggleElement.closest('.dropdown');
    const menu = dropdown.querySelector('.dropdown-menu');
    menu.style.display = (menu.style.display === 'flex') ? 'none' : 'flex';
    menu.style.flexDirection = 'column';
};

document.addEventListener("click", function (e) {
    const dropdown = document.querySelector('.dropdown');
    if (!dropdown.contains(e.target)) {
        const menu = dropdown.querySelector('.dropdown-menu');
        if (menu) menu.style.display = 'none';
    }
});
